import { render, staticRenderFns } from "./GhanaFlagForm.vue?vue&type=template&id=305bdc85&scoped=true"
import script from "./GhanaFlagForm.vue?vue&type=script&lang=js"
export * from "./GhanaFlagForm.vue?vue&type=script&lang=js"
import style0 from "./GhanaFlagForm.vue?vue&type=style&index=0&id=305bdc85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305bdc85",
  null
  
)

export default component.exports